import React, {useEffect} from 'react'
import {Grid, Typography} from '@mui/material'
import translationApi from '../../services/api/translations/translationService'
import LanguageTranslations from '../../utils/textConst'

export default function SubmissionBlocker({type, sourcelanguage, language}) {
  // useEffect(() => {
  //   if (language !== sourcelanguage) {
  //     translationApi
  //       .getTranslationsForText(language, sourcelanguage, [
  //         closedMessage,
  //         endMessage,
  //         alreadySubmittedMessage,
  //       ])
  //       .then(translations => {
  //         setClosedMessage(translations[0])
  //         setEndMessage(translations[1])
  //         setAlreadySubmittedMessage(translations[2])
  //       })
  //   }
  // }, [language])

  useEffect(() => {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('point_enabled='))

    console.log('Submission blocker page cookie check:', {
      cookieValue: cookieValue?.split('=')[1],
      hasPoint: !!window.Point?.togglePoint,
    })

    // Only initialize the widget state once
    if (window.Point?.togglePoint) {
      // If cookie exists and is true, widget should be enabled
      if (cookieValue && cookieValue.split('=')[1] === 'true') {
        document.body.classList.add('point_enabled')
        console.log(
          'Submission blocker page cookie check: adding point_enabled class'
        )
        document.cookie = `point_enabled=true; max-age=${90 * 24 * 60 * 60}; path=/`

        window.Point.togglePoint()
        console.log(
          'Submission blocker page cookie check: setting cookie to true',
          window.Point.togglePoint()
        )
      } else {
        // If cookie is false or doesn't exist, widget should be disabled
        document.body.classList.remove('point_enabled')
        window.Point.togglePoint()
        // Set cookie to false if it doesn't exist
        if (!cookieValue) {
          document.cookie = `point_enabled=false; max-age=${90 * 24 * 60 * 60}; path=/`
        }
      }
    }
  }, [])
  return (
    <Grid container>
      <Grid item xs={12}>
        <div className="welcome" id="survey-content">
          <Typography variant="h1">
            {type === 'closed' ? (
              LanguageTranslations.getLanguage(language).closedMessage
            ) : type === 'end' ? (
              <div>{LanguageTranslations.getLanguage(language).endMessage}</div>
            ) : (
              LanguageTranslations.getLanguage(language).alreadySubmitted
            )}
          </Typography>
        </div>
      </Grid>
    </Grid>
  )
}
